module.exports = __webpack_public_path__ + "static/media/card4_1@2x.9465125a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_208/images/card4_1@2x.png
// module id = 1715
// module chunks = 0